import https from './index'
import qs from 'qs'
import  URLS from "./lz.js"

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 视频上传
 */
export function videoUpload(data) {
    return https({
        url:URLS.FansUpLoadUrl + '/file/videoUpload',
        method: "post",
        authToken:true,
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取公告列表
 */
export function announcementlist(params) {
    return https({
        url:URLS.FansGroupUrl + '/announcement/list',
        method: "GET",
        authToken:true,
        params,
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取公告详情
 */
export function announcementdetail(params) {
    return https({
        url:URLS.FansGroupUrl + '/announcement/detail',
        method: "GET",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取咨询列表
 */
export function articleinfo(params) {
    return https({
        url:URLS.FansGroupUrl + '/article/info/list',
        method: "GET",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 相关咨询列表
 */
export function relationList(params) {
    return https({
        url:URLS.FansGroupUrl + '/article/info/relationList',
        method: "GET",
        authToken:true,
        params,
    })
}



/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 咨询详情
 */
export function articledetail(params) {
    return https({
        url:URLS.FansGroupUrl + '/article/info/detail',
        method: "GET",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {anchorUId}  主播id
 * @returns
 * @description 获取资讯信息评论
 */
export function getcommentList(params) {
	// opt.header['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    return https({
        url:URLS.FansGroupUrl + '/article/operation/commentList',
        method: "get",
        params,
        authToken:true,
      })
}





/**
 *
 * @param {anchorUId}  主播id
 * @returns
 * @description 获取资讯信息评论 二级
 */
export function articlechildCommentList(params) {
	// opt.header['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    return https({
        url:URLS.FansGroupUrl + '/article/operation/childCommentList',
        method: "get",
        params,
        authToken:true,
    })
}






/**
 *
 * @param {anchorUId}  主播id
 * @returns
 * @description 资讯信息评论 一
 */
export function viewArticle(data) {
	// opt.header['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    return https({
        url:URLS.FansGroupUrl + '/article/operation/viewArticle',
        method: "post",
         data:qs.stringify(data),
        authToken:true,
    })
}

/**
 *
 * @param {anchorUId}  主播id
 * @returns
 * @description 资讯信息评论 一
 */
export function operationcomment(data) {
	// opt.header['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    return https({
        url:URLS.FansGroupUrl + '/article/operation/comment',
        method: "post",
         data:qs.stringify(data),
        authToken:true,
    })
}



/**
 *
 * @param {anchorUId}  主播id
 * @returns
 * @description 资讯信息评论 二级
 */
export function operationcommentReply(data) {
	// opt.header['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    return https({
        url:URLS.FansGroupUrl + '/article/operation/commentReply',
        method: "post",
        data:qs.stringify(data),
        authToken:true,
    })
}































/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取视频数据
 */
export function statisticALL(params) {
    return https({
        url:URLS.FansGroupUrl + '/video/statistic/all',
        method: "get",
        authToken:true,
        params,
    })
}



/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 热门视频
 */
export function videoHotList(params) {
    return https({
        url:URLS.FansGroupUrl + '/video/info/hotList',
        method: "get",
        authToken:true,
        params,
    })
}

//
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取标签列表
 */
export function videoTagList(params) {
    return https({
        url:URLS.FansGroupUrl + '/video/relation/videoTagList',
        method: "get",
        params,
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 查询用户信息
 */
export function getUserInfo(params) {
    return https({
        url:URLS.rootApi + '/v1/profile/user',
        method: "get",
        params,
    })
}


//

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取分类列表
 */
export function livedatas(params) {
    return https({
        url:URLS.rootApi + '/v1/live/datas',
        method: "get",
        params,
    })
}



/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取分类列表
 */
export function getcategories(params) {
    return https({
        url:URLS.rootApi + '/v1/list/categories/all',
        method: "get",
        params,
    })
}



/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 草稿箱列表
 */
export function videoDraftlist(params) {
    return https({
        url:URLS.FansGroupUrl + '/videoDraft/list',
        method: "get",
        params,
        authToken:true,
    })
}



/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 视频发布列表
 */
export function publishList(params) {
    return https({
        url:URLS.FansGroupUrl + '/video/info/publishList',
        method: "get",
        params,
        authToken:true,
    })
}


//
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 删除草稿箱视频
 */

export function videoDraftDel(params) {
    return https({
        url:URLS.FansGroupUrl + '/videoDraft/delete',
        method: "get",
        params,
        authToken:true,
    })
}
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 删除短视频
 */

export function videodel(params) {
    return https({
        url:URLS.FansGroupUrl + '/video/info/del',
        method: "get",
        params,
        authToken:true,
    })
}




/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 删除草稿箱id
 */
export function videoDraftdelete(params) {
    return https({
        url:URLS.FansGroupUrl + '/videoDraft/delete',
        method: "get",
        authToken:true,
        params,
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 评论列表
 */
export function commentList(params) {
    return https({
        url:URLS.FansGroupUrl + '/video/operation/commentList',
        method: "get",
        authToken:true,
        params,
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 子评论列表
 */
export function childCommentList(params) {
    return https({
        url:URLS.FansGroupUrl + '/video/operation/childCommentList',
        method: "get",
        authToken:true,
        params,
    })
}



/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 删除评论id
 */
export function commentDel(params) {
    return https({
        url:URLS.FansGroupUrl + '/video/operation/commentDel',
        method: "get",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 评论回复
 */
export function VideoComment(data) {
    return https({
        url:URLS.FansGroupUrl + '/video/operation/comment',
        method: "post",
        authToken:true,
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 评论回复
 */
export function commentReply(data) {
    return https({
        url:URLS.FansGroupUrl + '/video/operation/commentReply',
        method: "post",
        authToken:true,
        data:qs.stringify(data),
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 评论的点赞
 */
export function commentLike(data) {
    return https({
        url:URLS.FansGroupUrl + '/video/operation/commentLike',
        method: "post",
        authToken:true,
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 保存短视频
 */
export function videoSave(data) {
    return https({
        url:URLS.FansGroupUrl + '/video/info/save',
        method: "post",
        authToken:true,
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 保存短视频到草稿箱
 */
export function videoDraftsave(data) {
    return https({
        url:URLS.FansGroupUrl + '/videoDraft/save',
        method: "post",
        authToken:true,
        data:qs.stringify(data),
    })
}



// WEBPACK FOOTER //
// ./src/api/video.js